module.exports = __webpack_public_path__ + "bf9237f53757b71506d6d05bcfe48b07.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/792.png
// module id = 1700
// module chunks = 2